/** 控制变量法违规检测：对齐 tech/108 §5，物理实验的核心不是装配关系而是控制变量。 */

export interface VariableSelectionInput {
  changed: string;
  controlled: string[];
}

export interface VariableSelectionExpectation {
  independentVar?: string;
  controlledVars?: string[];
}

export interface VariableSelectionResult {
  correct: boolean;
  violations: string[];
}

export function checkVariableSelection(
  selection: VariableSelectionInput,
  expected: VariableSelectionExpectation,
): VariableSelectionResult {
  const violations: string[] = [];

  if (expected.independentVar && selection.changed !== expected.independentVar) {
    violations.push(`应改变 "${expected.independentVar}"，实际选择了 "${selection.changed}"`);
  }

  const expectedControlled = expected.controlledVars ?? [];
  const missing = expectedControlled.filter((id) => !selection.controlled.includes(id));
  if (missing.length > 0) {
    violations.push(`未声明保持不变：${missing.join(", ")}`);
  }

  if (expected.independentVar && selection.controlled.includes(expected.independentVar)) {
    violations.push(`不应把要研究的变量 "${expected.independentVar}" 也声明为保持不变`);
  }

  return { correct: violations.length === 0, violations };
}
